var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input-checkbox',{staticClass:"mt-2",model:{value:(_vm.dataAvalancheAll),callback:function ($$v) {_vm.dataAvalancheAll=$$v},expression:"dataAvalancheAll"}},[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("View all avalanche history")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }